var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRetail = function SvgRetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27485 8.13811L2.25391 8.18528H2.25531C2.09068 8.5912 2 9.03501 2 9.5C2 10.4537 2.38141 11.3182 3 11.9495V20H2V22H22V20H21V11.9495C21.6186 11.3182 22 10.4537 22 9.5C22 9.03501 21.9093 8.5912 21.7447 8.18528H21.7466L19.0002 2H5.00021L2.32529 8.02451C2.30782 8.06202 2.29101 8.0999 2.27485 8.13811ZM19 20V12.9646C18.8367 12.9879 18.6698 13 18.5 13C17.027 13 15.7665 12.09 15.25 10.8015C14.7335 12.09 13.473 13 12 13C10.527 13 9.26647 12.09 8.75 10.8015C8.23353 12.09 6.97303 13 5.5 13C5.33024 13 5.1633 12.9879 5 12.9646V20H8V14H16V20H19ZM15.2553 8.18528L15.25 8.19846L15.2447 8.18528H15.2553ZM8.74469 8.18528L8.75 8.19846L8.75532 8.18528H8.74469Z",
    fill: "currentColor"
  })));
};
export default SvgRetail;